import FilterBtn from "./filter-btn";



export default function FilterBtnContainer (){
    return(
        <div
        className="pointer-events-auto h-full bg-white
         pl-4 flex items-center"
      >
        <FilterBtn />
      </div> 
    )
}